import { ChatListAtom, ChatListReducerAction } from '../typings';

export const chatListReducer = (
  prev: ChatListAtom,
  action: ChatListReducerAction
): ChatListAtom => {
  const { type, data } = action;

  if (type) {
    return {
      ...prev,
      [type]: data,
    };
  }

  return prev;
};
